module.exports = __webpack_public_path__ + "assets/img/half_field_right.e2a89107.png";